export enum ProjectHoursBillingBy {
  PROJECT = 'PROJECT',
  CUSTOMER = 'CUSTOMER',
  ORDER_CONFIRMATION = 'ORDER_CONFIRMATION',
}
